import React from "react";
import { Loader2, CheckCircle2, XCircle } from "lucide-react"; // Lucide icons
import "./LoadingScreen.scss";

const LoadingScreen = ({ status = "loading", message = "Loading..." }) => {
  const renderIcon = () => {
    switch (status) {
      case "success":
        return <CheckCircle2 className="icon success" />;
      case "error":
        return <XCircle className="icon error" />;
      default:
        return <Loader2 className="icon spinner" />;
    }
  };

  return (
    <div className="loading-screen">
      <div className="loading-message bounce-text">
        {renderIcon()}
        <h1 className="loader-text">{message}</h1>
      </div>
    </div>
  );
};

export default LoadingScreen;
